
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkAuthentication, login } from './adminSlice';
import { useNavigate } from 'react-router-dom';
import branchOnboardingLogo from "../img/branchOnboardingLogo.png";

function Signin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector(state => state.admin.isAuthenticated);

  useEffect(() => {
    dispatch(checkAuthentication());
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      // AdminHome's URL-redirect effect picks the correct landing page based
      // on role (HR/Accounting/Super Admin → /admin/onboarding-profiles,
      // Employee → /employee/generate-link).
      navigate('/admin');
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = () => {
    dispatch(login());
  };

  return (
	<div className="flex min-h-screen w-full items-center justify-center bg-custom-pink px-4">
		{/* 400×400 card: logo 60px from the top edge, button 20px from the bottom. */}
		<div className="flex w-full max-w-[400px] flex-col items-center rounded-2xl border-2 border-custom-orange px-6 pt-[49px] pb-[19px]">
			{/* The PNG has ~26% transparent space under the artwork; the 4:3 box
			    crops it so the gap to the button is the visible one. */}
			<img
				src={branchOnboardingLogo}
				alt="Branch Onboarding"
				className="aspect-[4/3] w-full max-w-[288px] object-cover object-top"
			/>
			<button
				onClick={handleLogin}
				type="button"
				className="mt-[70px] flex h-10 w-full max-w-[250px] items-center justify-center rounded bg-custom-purple px-4 text-xl font-bold text-white transition-opacity hover:opacity-90"
			>
				Continue to Login
			</button>
		</div>
	</div>


  	);
}

export default Signin;
